import { render, staticRenderFns } from "./BudgetDuplicateBtn.vue?vue&type=template&id=6edb5554&"
import script from "./BudgetDuplicateBtn.vue?vue&type=script&lang=js&"
export * from "./BudgetDuplicateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports